import { getValue } from '../../../utilities/local_storage';
import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent, setSponsoredBehaviourEvent } from '../ga_interface';

function openNotifyWhenRestockedLightbox(sku) {
    const category = GA_EVENTS.catalogProductTile.category;
    const action = GA_EVENTS.catalogProductTile.actions.openNotifyWhenRestockedLightbox;

    setBehaviourEvent({ category, action, label: sku });
}

function clickOnProduct(type, position) {
    const category = GA_EVENTS.catalogProductTile.category;
    const action = GA_EVENTS.catalogProductTile.actions.click;
    const label = type + ' - ' + position;

    setBehaviourEvent({ category, action, label, beforeUnload: true });
}

function loadAdCatalog(obj) {
    const category = GA_EVENTS.catalogProductAdTile.category;
    const eventName = GA_EVENTS.catalogProductAdTile.actions.catalogView;
    const action = eventName;
    const value = obj.price;
    const label = getTyreLabel();
    const spinach_id = obj.sku;
    const sponsored_product_details = getSponsoredProductUri();
    const sposored_product_brand = obj.manufacturer;
    const sposored_product_model = obj.model;
    const sposored_product_dimensions = obj.dimensions;
    const sposored_product_state = getValue('shippingState');

    setSponsoredBehaviourEvent({
        category,
        action,
        label,
        value,
        spinach_id,
        sponsored_product_details,
        sposored_product_brand,
        sposored_product_model,
        sposored_product_dimensions,
        sposored_product_state,
        beforeUnload: true,
    });
}

function loadAdPDP(obj) {
    const category = GA_EVENTS.catalogProductAdTile.category;
    const eventName = GA_EVENTS.catalogProductAdTile.actions.PDPView;
    const action = eventName;
    const value = obj.price;
    const label = getSponsoredProductUri('pdp');
    const spinach_id = obj.sku;
    const sponsored_product_details = getSponsoredProductUri('pdp');
    const sposored_product_brand = obj.manufacturer;
    const sposored_product_model = obj.model;
    const sposored_product_dimensions = obj.dimensions;
    const sposored_product_state = getValue('shippingState');

    setSponsoredBehaviourEvent({
        category,
        action,
        label,
        value,
        spinach_id,
        sponsored_product_details,
        sposored_product_brand,
        sposored_product_model,
        sposored_product_dimensions,
        sposored_product_state,
        beforeUnload: true,
    });
}

function clickOnAdProduct(obj) {
    const category = GA_EVENTS.catalogProductAdTile.category;
    const eventName = GA_EVENTS.catalogProductAdTile.actions.catalogClick;
    const action = eventName;
    const value = obj.price;
    const label = getTyreLabel();
    const spinach_id = obj.sku;
    const sponsored_product_details = getSponsoredProductUri();
    const sposored_product_brand = obj.manufacturer;
    const sposored_product_model = obj.model;
    const sposored_product_dimensions = obj.dimensions;
    const sposored_product_state = getValue('shippingState');

    setSponsoredBehaviourEvent({
        category,
        action,
        label,
        value,
        spinach_id,
        sponsored_product_details,
        sposored_product_brand,
        sposored_product_model,
        sposored_product_dimensions,
        sposored_product_state,
        beforeUnload: true,
    });
}

function clickOnAddToCartAdProduct(obj) {
    const category = GA_EVENTS.catalogProductAdTile.category;
    const eventName = GA_EVENTS.catalogProductAdTile.actions.catalogAddToCartClick;
    const action = eventName;
    const value = obj.price;
    const label = getTyreLabel();
    const spinach_id = obj.tyreId;
    const sponsored_product_details = getSponsoredProductUri();
    const sposored_product_brand = obj.manufacturer;
    const sposored_product_model = obj.model;
    const sposored_product_dimensions = obj.dimensions;
    const sposored_product_state = getValue('shippingState');

    setSponsoredBehaviourEvent({
        category,
        action,
        label,
        value,
        spinach_id,
        sponsored_product_details,
        sposored_product_brand,
        sposored_product_model,
        sposored_product_dimensions,
        sposored_product_state,
        beforeUnload: true,
    });
}

function clickOnViewDetailsAdProduct(obj) {
    const category = GA_EVENTS.catalogProductAdTile.category;
    const eventName = GA_EVENTS.catalogProductAdTile.actions.catalogViewDetailsClick;
    const action = eventName;
    const value = obj.price;
    const label = getTyreLabel();
    const spinach_id = obj.tyreId;
    const sponsored_product_details = getSponsoredProductUri();
    const sposored_product_brand = obj.manufacturer;
    const sposored_product_model = obj.model;
    const sposored_product_dimensions = obj.dimensions;
    const sposored_product_state = getValue('shippingState');

    setSponsoredBehaviourEvent({
        category,
        action,
        label,
        value,
        spinach_id,
        sponsored_product_details,
        sposored_product_brand,
        sposored_product_model,
        sposored_product_dimensions,
        sposored_product_state,
        beforeUnload: true,
    });
}

function getSponsoredProductUri(isPDP) {
    let label = '';
    
    if (isPDP) {
        label = location.href.substring(location.href.lastIndexOf('/') + 1).replace('.html', '');
    } else {
        label = location.href.substring(location.href.indexOf('://') + 3);
        label = label.substring(label.indexOf('/'));
    }

    return label;
}

function getTyreLabel() {
    if (location.href.indexOf('/tyre/') === -1) {
        return '';
    }
    let label = location.href.substring(location.href.indexOf('/tyre/') + 6);
    label = label ? label.replaceAll('/', '-') : '';

    if (label.indexOf('?') !== -1) {
        label = label.substring(0, label.indexOf('-?'))
    }

    if (label[label.length - 1] === '-') {
        label = label.slice(0, -1);
    }

    return label;
}

export {
    openNotifyWhenRestockedLightbox,
    clickOnProduct,
    clickOnAdProduct,
    loadAdCatalog,
    clickOnAddToCartAdProduct,
    loadAdPDP,
    clickOnViewDetailsAdProduct,
};